import { useState } from "react";
import { useNavigate } from "react-router-dom";
import Util from "../../util/util";

function HomeSearch() {
  const [keyword, setKeyword] = useState("");
  const [category, setCategory] = useState("");
  const [location, setLocation] = useState("");
  const categoryList = Util.getJobCategoryList();
  const navigate = useNavigate();

  const handleClickSearch = () => {
    //console.log("on click search");
    let jobListPath = "/job-list";

    // add url for category
    let appendCat = category && category !== "" ? category : "all";
    jobListPath = jobListPath + "/" + appendCat;

    // add url for location
    let appendLoc = location && location !== "" ? location : "all";
    jobListPath = jobListPath + "/" + appendLoc;

    // add url for keyword
    let appendKeyword = keyword && keyword !== "" ? keyword : "";
    jobListPath = jobListPath + "/" + appendKeyword;

    navigate(jobListPath);
  };

  return (
    <div
      className="container-fluid bg-primary mb-5 wow fadeIn"
      data-wow-delay="0.1s"
      style={{ padding: "35px" }}
    >
      <div className="container">
        <div className="row g-2">
          <div className="col-md-10">
            <div className="row g-2">
              <div className="col-md-4">
                <input
                  type="text"
                  id="keyword"
                  className="form-control border-0"
                  placeholder="Keyword"
                  onChange={(event) => setKeyword(event.target.value)}
                />
              </div>
              <div className="col-md-4">
                <select
                  className="form-select border-0"
                  defaultValue="Category"
                  onChange={(event) => setCategory(event.target.value)}
                >
                  <option disabled>Category</option>
                  {categoryList.map((category, index) => (
                    <option key={index}>{category}</option>
                  ))}
                </select>
              </div>
              <div className="col-md-4">
                <input
                  type="text"
                  className="form-control border-0"
                  placeholder="Location"
                  onChange={(event) => setLocation(event.target.value)}
                />
              </div>
            </div>
          </div>
          <div className="col-md-2">
            <button
              className="btn btn-dark border-0 w-100"
              onClick={handleClickSearch}
            >
              Search
            </button>
          </div>
        </div>
      </div>
    </div>
  );
}

export default HomeSearch;
